import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewContainerRef, ViewEncapsulation } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { ComponentFactoryService } from "@obg/ngx.ui.core";

/**
 * Wrapper so that lazy-loaded components can be displayed in a modal.
 */
@Component({
	template: "",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class DialogLazyComponent implements OnInit {
	constructor(
		@Inject(MAT_DIALOG_DATA) private data: any,
		private compenentFactoryResolver: ComponentFactoryService,
		private viewContainerRef: ViewContainerRef
	) {}

	ngOnInit() {
		this.viewContainerRef
			.createComponent(this.compenentFactoryResolver.get(this.data.dialogLazyComponent))
			.changeDetectorRef.markForCheck();
	}
}
